/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface UrlInfoDto
 */
export interface UrlInfoDto {

    /**
     * HTTP method
     *
     * @type {string}
     * @memberof UrlInfoDto
     * @example GET
     */
    method: string;

    /**
     * Request path
     *
     * @type {string}
     * @memberof UrlInfoDto
     * @example /api/v1/users
     */
    path: string;
}
